import { render, staticRenderFns } from "./cabinet-fl44-external-purchase-block-request-button.vue?vue&type=template&id=2500aaad&scoped=true&"
import script from "./cabinet-fl44-external-purchase-block-request-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-external-purchase-block-request-button.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-external-purchase-block-request-button.vue?vue&type=style&index=0&id=2500aaad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500aaad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2500aaad')) {
      api.createRecord('2500aaad', component.options)
    } else {
      api.reload('2500aaad', component.options)
    }
    module.hot.accept("./cabinet-fl44-external-purchase-block-request-button.vue?vue&type=template&id=2500aaad&scoped=true&", function () {
      api.rerender('2500aaad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-external-purchase-block-request-button.vue"
export default component.exports